import axios from 'axios'
import store from '@/store'
import Urls from '@/router/urls'

console.log(process.env)

const updateLastActionTime = (uri) => {
  if (!store.getters.authToken || uri === Urls.Auth.Login || uri === Urls.Auth.Refresh) {
    return
  }

  store.dispatch('setLastActionTime', Math.floor(new Date() / 1000))
}

const parseErrorResponse = (error) => {
  if (!error.response) {
    return 'Not connected'
  }

  if (store.getters.authToken && error.response.status === 401) {
    store.dispatch('clearAuthToken')
    return 'Authentication required'
  }

  if (!error.response.data || !error.response.data.message) {
    return 'Unknown backend error'
  }

  const errorCode = error.response.data.code
    ? `ERROR ${ error.response.data.code }: `
    : 'ERROR: '

  return `${ errorCode } ${ error.response.data.message }`
}

export default {
  get (path = '', params = null) {
    let headers = {}

    if (store.getters.authToken) {
      headers.Authorization = `Bearer ${ store.getters.authToken }`
    }

    if (store.getters.userTenantId) {
      headers['ASP-Tenant-ID'] = store.getters.userTenantId
    }

    updateLastActionTime(path)

    return axios
      .get(`${ (process.env.NODE_ENV === 'development' ? process.env.axiosBaseURL : window.API_BASE) }${ path }`, { params, headers })
      .catch(err => {
        throw new Error(parseErrorResponse(err))
      })
  },

  post (path = '', params = null, fileUpload = false, fileDownload = false) {
    let headers = {}
    let options = {}

    if (store.getters.authToken) {
      headers.Authorization = `Bearer ${ store.getters.authToken }`
    }

    if (store.getters.userTenantId) {
      headers['ASP-Tenant-ID'] = store.getters.userTenantId
    }

    if (fileUpload) {
      headers['Content-Type'] = 'multipart/form-data'
    }

    if (fileDownload) {
      options = { responseType: 'blob' }
    }

    updateLastActionTime(path)

    return axios
      .post(`${ (process.env.NODE_ENV === 'development' ? process.env.axiosBaseURL : window.API_BASE) }${ path }`, params, { headers, ...options })
      .catch(err => {
        throw new Error(parseErrorResponse(err))
      })
  },

  put (path = '', params = null, fileUpload = false) {
    let headers = {}

    if (store.getters.authToken) {
      headers.Authorization = `Bearer ${ store.getters.authToken }`
    }

    if (store.getters.userTenantId) {
      headers['ASP-Tenant-ID'] = store.getters.userTenantId
    }

    if (fileUpload) {
      headers['Content-Type'] = 'multipart/form-data'
    }

    updateLastActionTime(path)

    return axios
      .put(`${ (process.env.NODE_ENV === 'development' ? process.env.axiosBaseURL : window.API_BASE) }${ path }`, params, { headers })
      .catch(err => {
        throw new Error(parseErrorResponse(err))
      })
  },

  delete (path = '', data = null) {
    let headers = {}

    if (store.getters.authToken) {
      headers.Authorization = `Bearer ${ store.getters.authToken }`
    }

    if (store.getters.userTenantId) {
      headers['ASP-Tenant-ID'] = store.getters.userTenantId
    }

    updateLastActionTime(path)

    return axios
      .delete(`${ (process.env.NODE_ENV === 'development' ? process.env.axiosBaseURL : window.API_BASE) }${ path }`, { data, headers })
      .catch(err => {
        throw new Error(parseErrorResponse(err))
      })
  },

  fetchFile (path = '', data = null, method = 'GET') {
    let headers = {}

    const url = new URL(`${ (process.env.NODE_ENV === 'development' ? process.env.axiosBaseURL : window.API_BASE) }${ path }`)
    url.search = new URLSearchParams(data).toString()

    if (store.getters.authToken) {
      headers.Authorization = `Bearer ${ store.getters.authToken }`
    }

    if (store.getters.userTenantId) {
      headers['ASP-Tenant-ID'] = store.getters.userTenantId
    }

    return fetch(url, { headers, method })
  }
}
